/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
 
import Vue from 'vue'
import App from './App.vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)
 
// axios
import axios from "./axios.js"
Vue.prototype.$http = axios
axios.defaults.baseURL = 'https://fleetcare.hawkmy.com/api' 
 
// Theme Configurations
import '../themeConfig.js'
 
// Globally Registered Components
import './globalComponents.js'
 
// Styles: SCSS
import './assets/scss/main.scss'
 
// Tailwind
import '@/assets/css/main.css'
 
// Vue Router
import router from './router' 

// Vuex Store
import store from './store/store'

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


//for filtering objects
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, { name: 'custom' , lodash: lodash })

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'


// Feather font icon
require('./assets/css/iconfont.css')

export const bus = new Vue();
// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';
  
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
